import GeneralFilter from '../../../../Model/GeneralFilter'

export default class HorseGenderFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
